'use strict';

const userInstantListForm = document.querySelector('#old_user_instant_list_form');
const newUserInstantListForm = document.querySelector('#new_user_instant_list_form');
const contactForm = document.querySelector('#contact-form');
const modalCloseButton = document.querySelector('button[data-dismiss="modal"]');

function toggleSpinner(target) {
    const actionButton = target.querySelector('.action-button-medium');
    const imgSpinner = actionButton.querySelector('img');
    const spinnerDisplay = imgSpinner.style.display;
    imgSpinner.style.display = spinnerDisplay === "block" ? "none" : "block";
}

function toggleDisableButton(target) {
    if (target) {
        const actionButton = target.querySelector('.action-button-medium');
        actionButton.disabled = !actionButton.disabled;
    }
}

function showContactModal() {
    const contactScreenModal = $('#contact-screen-modal');
    contactScreenModal.modal({
        show: true,
        backdrop: 'static',
    });
    resizeModal();
}

function submitInstantListForm(event) {
    event.preventDefault();
    event.stopPropagation();

    toggleSpinner(event.target);
    toggleDisableButton(event.target);
    $.ajax({
        url: userInstantListForm.action,
        type: 'POST',
        data: new FormData(userInstantListForm),
        contentType: false,
        processData: false,
        success: function (response) {
            if (response.status === "ok") {
                if (response.redirect_url) {
                    window.location.href = response.redirect_url;
                    return true;
                }
                if (response.show_contact) {
                    showContactModal();
                    return true;
                }
                return true;
            }
        },
        complete: function () {
            toggleSpinner(event.target);
        }
    });
}

function submitNewInstantListForm(event) {
    event.preventDefault();
    event.stopPropagation();

    toggleSpinner(event.target);
    toggleDisableButton(event.target);
    $.ajax({
        url: newUserInstantListForm.action,
        type: 'POST',
        data: new FormData(newUserInstantListForm),
        contentType: false,
        processData: false,
        success: function (response) {
            if (response.status === "ok") {
                if (response.redirect_url) {
                    window.location.href = response.redirect_url;
                    return true;
                }
                if (response.show_contact) {
                    showContactModal();
                    return true;
                }
                return true;
            }
        },
        complete: function () {
            toggleSpinner(event.target);
        }
    });
}

function updateContactFormValidity(form) {
    Array.from(form.querySelectorAll('.form-group .form-check-input, .form-group .form-control'))
        .forEach(item => {
            const helpText = item.closest('.form-group').querySelector('.help-text-error');
            helpText.style.display = item.validity.valid ? 'none' : 'block';
            helpText.textContent = helpText.dataset.error;
        });
}

function validateFullName() {
    const fullName = contactForm.querySelector('.form-control[name=first_name]');
    const result = /^(?![-\s]+$)[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s-]{1,50}$/.test(fullName.value);
    if (result) {
        fullName.setCustomValidity("");
    } else {
        fullName.setCustomValidity("Wprowadź poprawne imię i nazwisko");
    }
}

function validatePhone() {
    const phoneInput = contactForm.querySelector('.form-control[name=phone_number]');
    const isRequired = phoneInput.hasAttribute('required');
    const phoneValue = phoneInput.value;

    const phonePattern = /^\+?\d{9,14}$/;
    const cleanedPhone = phoneValue.replace(/[\s\-]/g, '');

    if (isRequired) {
        if (cleanedPhone === '' ||  !phonePattern.test(cleanedPhone)) {
            phoneInput.setCustomValidity("Wprowadź poprawny numer telefonu");
        } else {
            phoneInput.setCustomValidity("");
        }
    } else {
        if (cleanedPhone !== '' && !phonePattern.test(cleanedPhone)) {
            phoneInput.setCustomValidity("Wprowadź poprawny numer telefonu");
        } else {
            phoneInput.setCustomValidity("");
        }
    }
}

function submitContactForm(event) {
    event.preventDefault();
    event.stopPropagation();
    validateFullName();
    validatePhone();
    updateContactFormValidity(contactForm);
    if (contactForm.checkValidity()) {
        toggleSpinner(event.target);
        toggleDisableButton(event.target);

        $.ajax({
            url: contactForm.action,
            type: 'POST',
            data: new FormData(contactForm),
            contentType: false,
            processData: false,
            success: function (response) {
                if (response.status === "ok") {
                    if (response.redirect_url) {
                        window.location.href = response.redirect_url;
                        return true;
                    }
                    return true;
                }
            },
            error: function (response) {
                const responseJSON = response.responseJSON;
                for (let field_name of Object.keys(responseJSON)) {
                    const field = contactForm.querySelector(`.form-group .form-control[name="${field_name}"]`);
                    if (field) {
                        const helpText = field.closest('.form-group').querySelector('.help-text-error');
                        helpText.style.display = 'block';
                        helpText.textContent = responseJSON[field_name][0];
                    }
                }
            },
            complete: function () {
                toggleSpinner(event.target);
                toggleDisableButton(event.target);
            }
        });
    }
}


function handleCloseModal() {
    toggleDisableButton(userInstantListForm);
    toggleDisableButton(newUserInstantListForm);
}

(function () {
    'use strict';
    if (userInstantListForm) userInstantListForm.addEventListener('submit', submitInstantListForm, false);
    if (newUserInstantListForm) newUserInstantListForm.addEventListener('submit', submitNewInstantListForm, false);
    if (contactForm) contactForm.addEventListener('submit', submitContactForm, false);
    if (modalCloseButton) modalCloseButton.addEventListener('click', handleCloseModal, false);
})();
